import fetchJsonp from 'fetch-jsonp';

export const fetchSuggestions = (query: string) => {
  const url = `https://services.inivio.com.au/autocomplete/address/address?address=${encodeURIComponent(query)}`;
  return fetchJsonp(url).then(r => r.json())
    .then(j => {
      return j['Result'] as (Array<string> | null) || [];
    })
    // If api is offline, return an empty list so everything still works nicely.
    .catch(e=> []); 
}
